import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid
} from "recharts";

export default function RecruiterConversionGraph({ recruiters, title }) {
  const data = recruiters.map((user) => ({
    name: user.user_name,
    Demand: user.total_positions || 0,
    Submissions: user.total_submissions || 0,
    Shortlisted: user.total_shortlisted || 0,
    L1: user.total_l1_scheduled || 0,
    L2: user.total_l2_scheduled || 0,
    L3: user.total_l3_scheduled || 0,
    FinalSelect: user.total_hired || 0,
    Offer: user.total_offer || 0,
    Joined: user.total_started || 0,
  }));

  return (
    <div className="card shadow-sm">
      <div className="card-body" style={{ height: "65vh", minHeight: 400 }}>
        <h5 className="mb-3">{title}</h5>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} angle={-30} textAnchor="end" />
            <YAxis />
            <Tooltip />
            <Legend />

            {/* Each stage as a line */}
            <Line type="monotone" dataKey="Demand" stroke="#8884d8" />
            <Line type="monotone" dataKey="Submissions" stroke="#82ca9d" />
            <Line type="monotone" dataKey="Shortlisted" stroke="#ffc658" />
            <Line type="monotone" dataKey="L1" stroke="#ff8042" />
            <Line type="monotone" dataKey="L2" stroke="#00c49f" />
            <Line type="monotone" dataKey="L3" stroke="#0088fe" />
            <Line type="monotone" dataKey="FinalSelect" stroke="#a83279" />
            <Line type="monotone" dataKey="Offer" stroke="#6f42c1" />
            <Line type="monotone" dataKey="Joined" stroke="#28a745" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}